export default (Vue: any) => {
  Vue.directive("imgerror", {
    inserted: function(el: any, binding: any, vnode: any, oldVnode: any) {
      el.addEventListener(
        "error",
        function(e: any) {
          console.log(e);
        },
        false
      );
      // let styleEl = getComputedStyle(el, null)
    }
  });

  let clTime;
  Vue.directive("dacusClick", {
    componentUpdated: function(
      el: any,
      binding: any,
      vnode: any,
      oldVnode: any
    ) {
      /*if(true) {
          el.disabled = true
          clTime = setTimeout(()=>{
            el.disabled = false
          },1000)
        }*/
    }
  });
};
